import { render, staticRenderFns } from "./TeamScoreViewer.vue?vue&type=template&id=3249ad72&scoped=true&"
import script from "./TeamScoreViewer.vue?vue&type=script&lang=js&"
export * from "./TeamScoreViewer.vue?vue&type=script&lang=js&"
import style0 from "./TeamScoreViewer.vue?vue&type=style&index=0&id=3249ad72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3249ad72",
  null
  
)

export default component.exports